import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {} from '../../cellcomAbroadBlockSlice';
import images from '../images/images';
import './CantChangeStartDateFamilyOrCanCancelFamily.scss';
import {isMobile} from 'react-device-detect';

const tel = window.Config.numberCallCenterAbroad;
const CantChangeStartDateFamilyOrCanCancelFamily = ({cancelPackage, onClose, isPermissive = false}) => {
  const permissiveRender = (
    <>
      <div className='bottom-paragraph'>
        לא הצלחנו לבצע את הפעולה. <br />
        כיוון שלמנוי זה מקושרות חבילות של בני משפחה
      </div>
      <div className='top-paragraph'>ניתן לבצע את הפעולה ע"י נציג שרות</div>
    </>
  );
  const regularRender = (
    <>
      <div className='bottom-paragraph'>
        לא הצלחנו להשלים את העדכון. <br />
        מה יכולה להיות הסיבה?
      </div>
      <div className='top-paragraph'>
        אחד המנויים המשפחתיים השייכים לחבילה
        <br />
        זו נמצא בחו"ל עם חבילה מוזלת
        <br />
        עברו 14 ימים או יותר מיום רכישת החבילה
      </div>
    </>
  );
  return (
    <div className='cancel-package-family-pop-up-container'>
      <div className='header'>רגע, זה לא עבד</div>
      {isPermissive ? regularRender : permissiveRender}
      <div className='contact-box'>
        <span className='txt-header'>
          אנחנו כאן לבירורים<span className='bold'> 24/7 ,</span>
          <br />
          <span className='bold'>בשיחת חינם מהארץ ומכל מקום בעולם</span>
        </span>
        <div className='under-box'>
          <Image className='phone-img' src={images.phoneCall} alt='phone' />
          {!isMobile ? (
            <span className='txt'>חיוג למוקד {window.Config.numberCallCenterAbroad}</span>
          ) : (
            <a href={`tel:${tel.replace('-', '')}`}>חיוג למוקד {window.Config.numberCallCenterAbroad}</a>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CantChangeStartDateFamilyOrCanCancelFamily);
